import React, { Fragment } from "react";

interface IProps {
  isOpen: boolean;
  closeModal: Function;
  columns: number;
  children: any;
}


const Modal:React.FC<IProps> = ({isOpen, closeModal, columns, children}) => {

  const closeModalClickBackground = (e) => {
    if(e.currentTarget === e.target) {
      closeModal();
    }
  }
  
  return (
    <Fragment>
      {isOpen &&
        <Fragment>
          <div className={columns === 1 ? 'modal__background columns-1' : 'modal__background columns-2'}>
            <div className='modal' onClick={(e) => closeModalClickBackground(e)}>
              <div className='modal__content'>
                <div className='modal__close' onClick={() => closeModal()}><i className="fa-sharp fa-solid fa-xmark"></i></div>
                <div className='modal__body'>
                  {children}
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      }
    </Fragment>
  )
}

export default Modal;
